import React from 'react';
import { UncontrolledAlert } from 'reactstrap';
class LoadingAlert extends React.Component {

    render() {
        const message = this.props.message
        // const show = this.props.show
        const alertcss = {
            boxSizing: "border-box",
            position: "fixed",
            top: "15px",
            right: 0,
            zIndex: 999999,
            width: "350px",
            padding: "0px 15px",
            maxHeight: "calc(100% - 30px)",
            overflowX: "hidden",
            overflowY: "auto",
        }
        return (
            message !== "" ?
                <div style={alertcss}>
                    <UncontrolledAlert className="alert-addon-card bg-info text-white shadow-lg">
                        <span className="icon-addon alert-addon">
                            <i className="zmdi zmdi-rotate-right zmdi-hc-spin zmdi-hc-lg" />
                        </span>
                        <span className="d-inline-block">{message}</span>
                    </UncontrolledAlert>
                </div> : ""
        );
    }
}

export default LoadingAlert;